import { get, getAll } from '@bigyouth/base'
import withScroll from '../hoc/withScroll'
import instantsearch from 'instantsearch.js'
import algoliasearch from 'algoliasearch/lite'

import customHitsEvents from '../utils/Lists/customHitsEvents'
import customHitsActuality from '../utils/Lists/customHitsActuality'
import customHitsTestimony from '../utils/Lists/customHitsTestimony'
import customHitsActualityProject from '../utils/Lists/customHitsActualityProject'
import customHitsProject from '../utils/Lists/customHitsProject'
import customHitsPress from '../utils/Lists/customHitsPress'
import customPagination from '../utils/Lists/customPagination'
import customStats from '../utils/Lists/customStats'
import customClear from '../utils/Lists/customClear'
import customCurrentRefinements from '../utils/Lists/customCurrentRefinements'
import customRefinementList from '../utils/Lists/customRefinementList'
import customCalendar from '../utils/Lists/customCalendar'
import customSortEvent from '../utils/Lists/customSortEvent'
import customSortBy2 from '../utils/Lists/customSortBy2'

import { configure, refinementList } from 'instantsearch.js/es/widgets'

import getOffset from '../utils/getOffset'

export default withScroll({
  name: 'algolia-list',

  ui: {
    results: '[js-algolia-list-results]',
    'numberItems[]': '[js-algolia-list-number-items]',
    pagination: '[js-algolia-list-pagination]',
    stats: '[js-algolia-list-stats]',
    toggle: '[js-algolia-list-toggle]',
    clear: '[js-algolia-list-clear]',
    clearMobile: '[js-algolia-list-clear-mobile]',
    'refinementsList[]': '[js-algolia-list-refinements-list]',
    actives: '[js-algolia-list-actives]',
    currentFilters: '[js-algolia-list-current]',
    type: '[js-algolia-list-type]',
    'panels[]': '[js-algolia-list-panel]',
    'togglePanel[]': '[js-algolia-list-toggle-panel]',
    'closeFilters[]': '[js-algolia-list-close-filters]',
    'backFilters[]': '[js-algolia-list-back-filters]',
    rangeDate: '[js-algolia-list-range-date]',
    rangeDateSingle: '[js-algolia-list-range-date-single]',
    mobileBar: '[js-algolia-list-mobile-bar]',
    refine: '[js-algolia-list-refine]',
    intro: '[js-algolia-list-intro]',
    sort: '[js-algolia-list-sort]',
    sort2: '[js-algolia-list-sort2]',
    sort2Toggle: '[js-algolia-list-sort2-toggle]',
    backMap: '[js-algolia-list-back-map]',
  },

  events: [
    {
      on: 'click',
      target: 'togglePanel',
      handle ({ target }) {
        get(`[js-algolia-list-panel][data-panel="${target.dataset.panel}"]`).classList.add('is-visible')
      },
    },
    {
      on: 'click',
      target: 'refine',
      handle ({ target }) {
        this.saveCurrentSearchState()
      },
    },
    {
      on: 'click',
      target: 'closeFilters',
      handle ({ target }) {
        // reset search to previous state since apply was not hit
        if (target.classList.contains('filters__close-button')) {
          this.unsetFilters()
        }

        setTimeout(() => {
          this.ui.panels.forEach((panel) =>
            panel.classList.remove('is-visible'),
          )
        }, 600)
      },
    },
    {
      on: 'click',
      target: 'backFilters',
      handle () {
        getAll('[js-algolia-list-panel].is-visible').forEach((panel) =>
          panel.classList.remove('is-visible'),
        )
      },
    },
  ],

  componentDidMount () {
    const indexName = `${config.algolia.env}_pages`
    const wrapperThis = this
    this.prevIsMap = sessionStorage.getItem('prevUrlIsMap')

    const searchClient = algoliasearch(
      process.env.ALGOLIA_APP_ID,
      process.env.ALGOLIA_API_KEY,
    )

    this.search = instantsearch({
      indexName: indexName,
      searchClient: searchClient,
      routing: {
        stateMapping: {
          stateToRoute (uiState) {
            const indexUiState = uiState[indexName]

            setTimeout(() => {
              wrapperThis.getBackMapUrl()
            }, 1000)

            return {
              theme: indexUiState.refinementList && indexUiState.refinementList['thematics.name'],
              country: indexUiState.refinementList && indexUiState.refinementList['countries.title'],
              continent: indexUiState.refinementList && indexUiState.refinementList.continent,
              city: indexUiState.refinementList && indexUiState.refinementList.city,
              eventType: indexUiState.refinementList && indexUiState.refinementList.eventType,
              actuType: indexUiState.refinementList && indexUiState.refinementList.actuType,
              expertises: indexUiState.refinementList && indexUiState.refinementList.expertises,
              profiles: indexUiState.refinementList && indexUiState.refinementList.profiles,
            }
          },
          routeToState (routeState) {
            return {
              [indexName]: {
                sortBy: routeState.isPast === 'true' && `${config.algolia.env}_pages_date`,
                refinementList: {
                  city: routeState.city,
                  continent: routeState.continent,
                  eventType: routeState.eventType,
                  actuType: routeState.actuType,
                  expertises: routeState.expertises,
                  profiles: routeState.profiles,
                  'countries.title': routeState.country,
                  'thematics.name': routeState.theme,
                },
              },
            }
          },
        },
      },
    })

    this.getBackMapUrl()

    // add widgets
    this.search.addWidgets([
      // global
      // "NOT noIndex:true" keeps a project news item marked noIndex out of
      // /des-nouvelles-de-nos-projets. NOT also matches a record with no
      // noIndex at all, so records indexed before the attribute existed stay
      // listed. noIndex must be in the index's attributesForFaceting
      // (filterOnly): without it Algolia silently ignores the filter and the
      // noIndex entries come back.
      configure({
        hitsPerPage: 12,
        filters: this.props.content === 'event' ? `timestampEndDate >= ${Date.now() / 1000} AND status:published AND locale:${config.locale} AND type:event` : `status:published AND locale:${config.locale} AND type:${this.props.content}${this.props.content === 'actuality-project' ? ' AND NOT noIndex:true' : ''}`,
      }),
      // current refinements list
      customCurrentRefinements({
        container: this.ui.currentFilters,
        currentTheme: null,
        currentSubtheme: null,
        currentSubthemeCount: null,
        suggestionsWrap: null,
        actives: this.ui.actives,
      }),
      // stats : in title, buttons etc
      customStats({
        container: this.ui.stats,
        type: this.props.content,
        pagination: this.ui.pagination,
        numberItems: this.ui.numberItems,
        nbHitsPerPage: 12,
      }),
      // clear all refinements
      customClear({
        container: this.ui.clear,
      }),
      // clear all refinements mobile
      customClear({
        container: this.ui.clearMobile,
      }),
      // pagination
      customPagination({
        container: this.ui.pagination,
        padding: window.innerWidth < 768 ? 1 : 2,
      }),
    ])

    // list of tags (city, thematics, countries etc ....)
    this.ui.refinementsList.forEach(list => {
      this.search.addWidgets([
        refinementList({
          container: list,
          limit: 200,
          attribute: list.dataset.attribute,
          sortBy (a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          },
          cssClasses: {
            root: 'is-themes',
          },
        }),
      ])
    })

    if (this.props.content !== 'project' && this.props.content !== 'testimony') {
      this.search.addWidgets([
        // for period
        customCalendar({
          container: this.ui.rangeDate,
          attribute: this.props.content === 'event' ? 'timestampStartDate' : 'timestampPublishDate',
          rangeDateSingle: this.ui.rangeDateSingle,
          minDate: false,
        }),
      ])
    }

    // add type for events + custom sort/toggle + custom hits
    if (this.props.content === 'event') {
      this.search.addWidgets([
        customRefinementList({
          container: this.ui.type,
          attribute: 'eventType',
          content: this.props.content,
          sortBy: ['label:asc'],
        }),
        // hits
        customHitsEvents({
          container: this.ui.results,
        }),
        // sort
        customSortEvent({
          container: this.ui.sort,
          searchInstance: this.search,
          indexName: indexName,
          items: [
            { label: 'Future', value: indexName },
            { label: 'Past', value: `${indexName}_date` },
          ],
        }),
      ])
    } else if (this.props.content === 'actuality') {
      this.search.addWidgets([
        customRefinementList({
          container: this.ui.type,
          attribute: 'actuType',
          sortBy: ['label:asc'],
          content: this.props.content,
        }),
        customHitsActuality({
          container: this.ui.results,
        }),
      ])
    } else if (this.props.content === 'project') {
      this.search.addWidgets([
        customHitsProject({
          container: this.ui.results,
        }),
      ])
    } else if (this.props.content === 'testimony') {
      this.search.addWidgets([
        customHitsTestimony({
          container: this.ui.results,
        }),
        // sort
        customSortBy2({
          container: this.ui.sort2,
          items: [
            { label: 'Du plus récent au plus ancien', value: indexName },
            { label: 'Du plus ancien au plus récent', value: `${indexName}_entry_date_asc` },
          ],
        }),
      ])

      this.ui.sort2Toggle.addEventListener('click', () => {
        this.ui.sort2.classList.toggle('is-active')
      })

      document.body.addEventListener('click', (e) => {
        if (!e.target.closest('[js-algolia-list-sort2]') && !e.target.closest('[js-algolia-list-sort2-toggle]')) {
          this.ui.sort2.classList.remove('is-active')
        }
      })
    } else if (this.props.content === 'press') {
      this.search.addWidgets([
        customHitsPress({
          container: this.ui.results,
        }),
        customRefinementList({
          container: this.ui.type,
          attribute: 'pressType',
          sortBy: ['label:asc'],
          content: this.props.content,
        }),
      ])
    } else {
      this.search.addWidgets([
        customHitsActualityProject({
          container: this.ui.results,
        }),
      ])
    }

    this.search.start()

    // GA4 events for events / projects / news and project news pages
    let eventName = ''

    switch (this.props.content) {
      case 'project':
        eventName = 'nos-projets-filtre-'
        break
      case 'actuality':
        eventName = 'actualites-filtre-'
        break
      case 'event':
        eventName = 'evenements-filtre-'
        break
      case 'actuality-project':
        eventName = 'des-nouvelles-de-nos-projets-filtre-'
        break
      case 'press':
        eventName = 'press-filtre-'
        break
      case 'testimony':
        eventName = 'testimony-filtre-'
        break
    }

    if (this.props.content === 'project' || this.props.content === 'actuality' || this.props.content === 'event' || this.props.content === 'actuality-project') {
      document.querySelector('body').addEventListener('click', (e) => {
        if (e.target.closest('.ais-RefinementList-item') && !e.target.classList.contains('ais-RefinementList-checkbox')) {
          const currentCheckbox = e.target.closest('.ais-RefinementList-item').querySelector('.ais-RefinementList-checkbox')

          const tags = []

          if (!e.target.closest('.ais-RefinementList-item').classList.contains('ais-RefinementList-item--selected')) {
            tags.push(currentCheckbox.value)
          }

          document.querySelectorAll('.ais-RefinementList-checkbox').forEach(filter => {
            if (filter.checked && filter !== currentCheckbox) {
              tags.push(filter.value)
            }
          })

          // eslint-disable-next-line no-undef
          _paq.push(['trackEvent', 'Click', 'Filtres Algolia', `${eventName}${tags.join(',')}`])
        }
      })
    }
  },

  getBackMapUrl () {
    if (this.ui.backMap && this.prevIsMap === 'true') {
      const params = new URLSearchParams(window.location.search)
      params.delete('country[0]')

      this.ui.backMap.classList.remove('is-hidden')
      this.ui.backMap.href = `${sessionStorage.getItem('prevUrl')}${Array.from(params).length !== 0 ? `?${params}` : ''}`
    }
  },

  onScroll ({ y }) {
    // mobile fixed search bar
    if (window.innerWidth < 768) {
      if (y > getOffset(this.ui.intro) + this.ui.intro.offsetHeight) {
        this.ui.mobileBar.classList.add('is-sticky')
      } else {
        this.ui.mobileBar.classList.remove('is-sticky')
      }
    }
  },

  saveCurrentSearchState () {
    this.savedSearchState = this.search.renderState[`${this.search.indexName}`].currentRefinements.items
  },

  unsetFilters () {
    const searchState = this.search.renderState[`${this.search.indexName}`].refinementList

    // if filters saved compare and uncheck or checl items
    if (this.savedSearchState.length > 0) {
      this.savedSearchState.forEach(item => {
        if (item.attribute === 'timestampStartDate' || item.attribute === 'timestampPublishDate') {
          const date = this.search.renderState[`${this.search.indexName}`].range[item.attribute]
          const start = item.refinements[0]
          const end = item.refinements[1]

          if (end !== null && end !== undefined) {
            date.refine([start.value, end.value])
          } else {
            date.refine([start.value])
          }
        } else {
          const widget = searchState[item.attribute]

          widget.items.forEach(filterItem => {
            const inSavedSearch = item.refinements.filter(refinement => refinement.value === filterItem.value).length > 0

            if ((filterItem.isRefined && !inSavedSearch) || (!filterItem.isRefined && inSavedSearch)) {
              widget.refine(filterItem.value)
            }
          })
        }
      })
    // if no filters saved, remove all checked items
    } else {
      this.ui.clear.querySelector('button').click()
    }
  },
})
